import * as classes from './ImageText.module.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const ImageText = ({ text, image }) => {
  if (!text || !image) return (<></>)

  return (
    <section className={`container-sm ${classes.sectionTextImage}`}>
      <div className={`container-text ${classes.textImage}`}>
        <div className={classes.left}>
          <img
            src={image.file?.url}
            alt={image.title}
            srcSet={`${image.file?.url}?fm=webp&h=300 322w, ${image.file?.url}?fm=webp&w=429 323w`}
            width={image.file?.details?.image?.width}
            height={image.file?.details?.image?.height}
          />
        </div>
        <div className={`ul-checked ${classes.right}`}>
          {documentToReactComponents(text)}
        </div>
      </div>
    </section>
  )
}

export default ImageText
